<app-header></app-header>
<p>categories works!</p>
<app-footer></app-footer>